export default __webpack_public_path__ + "static/media/CompanyLogoPlaceholder.a2a9881f.svg";